package com.milta.core.localization.translations.bg

import com.milta.core.localization.OptimizationQuotaStrings

internal val OptimizationQuota = OptimizationQuotaStrings(
    exhaustedTitle = "Квотата за оптимизации е достигната",
    exhaustedCreateRouteMessage = "Отново на {date}. Можете да създадете маршрута без оптимизация: въведеният ред се запазва.",
    exhaustedCreateBatchMessage = "Отново {limit} оптимизации на {date}. Пратката може да бъде създадена без оптимизация: въведеният ред се запазва.",
    quotaReachedResetOn = "Квотата за оптимизации е достигната — нулиране на {date}",
    routeCreatedInEnteredOrder = "Маршрутът е създаден във въведения ред.",
    routeWillBeCreatedInEnteredOrder = "Маршрутът ще бъде създаден във въведения ред.",
    batchCreatedInEnteredOrder = "Пратката е създадена без оптимизация, във въведения ред.",
    sendWithoutOptimization = "Изпрати без оптимизация",
    batchNotOptimizedTitle = "Пратката е създадена без оптимизация",
    batchNotOptimizedMessage = "Квотата за оптимизации е достигната. Текущият ред на спирките се запазва.",
    batchNotOptimizedMobileMessage = "Пратката е създадена без оптимизация: квотата е достигната. Въведеният ред е запазен, спирките са разпределени равномерно.",
    reoptimizeAction = "Преоптимизирай",
    reoptimizeUnavailableWeb = "Преоптимизацията не е налична: квотата е достигната, отново на {date}. Текущият ред се запазва и изпращането остава възможно.",
    reoptimizeUnavailableMobile = "Преоптимизацията не е налична до {date} (квотата е достигната). Изпращането остава възможно.",
    stopAddedAtEndTitle = "Спирката е добавена в края на маршрута",
    stopAddedAtEndMessage = "Квотата за оптимизации е достигната — нулиране на {date}. Редът на другите спирки не се променя.",
    reoptimizeExhaustedHint = "Квотата за оптимизации е достигната, отново на {date}",
    myOptimizationsTitle = "Моите оптимизации",
    remainingForPeriod = "Остават за периода",
    remainingSuffix = "остават",
    resetLabel = "Нулиране",
    resetAtRenewal = "При подновяване на абонамента",
    driverExplanation = "Нулира се при подновяване на абонамента ви. Шофьор на Фирма: броячът ви следва абонамента на Фирмата, с пробния лимит, докато тя е в пробен период.",
    enterpriseExplanation = "Нулира се при подновяване на абонамента ви. Този брояч обхваща само вашите оптимизации; всеки шофьор има свой.",
    webCounterNotice = "Този брояч обхваща само оптимизациите, стартирани от този акаунт. Всеки шофьор има свой, видим в приложението му.",
    historyTitle = "История",
    columnDate = "Дата",
    columnAction = "Действие",
    columnTarget = "Засегнат маршрут",
    columnOutcome = "Резултат",
    actionOptimizeRoute = "Оптимизиране на маршрут",
    actionCreateRouteBatch = "Създаване на пратка",
    actionReoptimizeRouteBatch = "Преоптимизиране на пратка",
    actionReoptimizeOnStopAdded = "Преоптимизиране при добавяне на спирка",
    actionReoptimizeInPlace = "Преоптимизиране в движение",
    actionCreateOwnRoute = "Създаване на моя маршрут",
    outcomeCounted = "Отчетена",
    outcomeRefunded = "Върната",
    outcomeRefundedLong = "Върната — грешка в RoutaR",
    refundedNotCounted = "грешка в RoutaR, не е отчетена",
    targetRoute = "Маршрут от {date}",
    targetBatch = "Пратка от {date}",
    historyLoadingMore = "Зареждане на следващите редове…",
    historyEnd = "Край на историята — {count} реда",
    historyEmpty = "Няма оптимизации за този период.",
    historyLoadError = "Историята не може да бъде заредена.",
    retryAction = "Опитай отново",
    loading = "Зареждане…",
    errorNoConnection = "Няма връзка със сървъра — проверете връзката си.",
    errorGeneric = "Възникна грешка. Опитайте отново по-късно.",
    tabOptimizations = "Оптимизации RoutaR",
    tabAiTokens = "AI токени",
    comingSoon = "Предстои",
    limitsDescription = "Брой разрешени оптимизации RoutaR на акаунт и на абонаментен период, според типа акаунт и статуса на абонамента. Броячът на всеки акаунт се нулира при подновяване на абонамента му.",
    columnTrial = "Пробен",
    columnPaid = "Платен",
    rowEnterprise = "Акаунт на Фирма",
    rowDriver = "Шофьор",
    fieldRequired = "Задължително поле.",
    fieldMustBePositive = "Трябва да е по-голямо от 0.",
    limitsFootnote = "Стойности в оптимизации за период. Шофьор на Фирма получава лимита „Шофьор“, пробен докато Фирмата му е в пробен период, иначе платен.",
    limitsSaved = "Лимитите са записани. Фирма: {enterpriseTrial} пробен · {enterprisePaid} платен. Шофьор: {driverTrial} пробен · {driverPaid} платен.",
    limitsRejected = "Стойностите са отхвърлени: всеки лимит трябва да е по-голям от 0.",
    saveAction = "Запиши",
    detailsAction = "Детайли",
    accountDetailsTitle = "Данни за потребителя",
    sectionIdentity = "Самоличност",
    accountTypeLabel = "Тип акаунт",
    kindEnterpriseOwner = "Акаунт на Фирма",
    kindEnterpriseDriver = "Шофьор на Фирма",
    kindIndependentDriver = "Независим шофьор",
    withoutOrganisation = "Без организация",
    subscriptionLabel = "Абонамент",
    viaOrganisation = "Чрез организация",
    subscriptionTrial = "Пробен",
    subscriptionPaid = "Платен",
    appliedLimitLabel = "Приложен лимит",
    limitKindEnterprise = "Лимит Акаунт на Фирма",
    limitKindDriver = "Лимит Шофьор",
    enterpriseInTrialSuffix = "(Фирмата е в пробен период)",
    resetSourceOwn = "Подновяване на абонамента",
    resetSourceEnterprise = "Подновяване на {enterprise}",
    exhaustedBadge = "Квотата е изчерпана",
    manuallyAdjustedBadge = "Заменено ръчно",
    replaceLabel = "Замени оставащия брой",
    replaceAction = "Замени",
    replaceHelp = "Само за текущия период. При нулирането акаунтът започва отново от глобалния лимит.",
    replaceHelpEnterpriseDriver = "Променя само брояча на {name}. Този на Фирмата и на другите шофьори не се променя.",
    replaceInvalid = "Въведете число, по-голямо или равно на 0.",
    replaceRejected = "Стойността е отхвърлена от сървъра.",
    replaceMaximum = "Максимум 100 000.",
    replacedBanner = "Оставащият брой е заменен: {from} → {to}. За текущия период. На {date} връщане към глобалния лимит ({limit}).",
    adminHistoryTitle = "История на оптимизациите",
    accountNotFound = "Акаунтът не е намерен.",
)
